const DEV = {
    baseUrl: "http://localhost:3002/v1/"
};
const PROD = {
    baseUrl: "https://warehouse.kjdelectronics.com/v1/"
};

const CONFIG = process.env.NODE_ENV.toLowerCase() === 'production' ? PROD : DEV;

export const config = CONFIG;